import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import './LoyaltyCard.css';
import BlueCardImage from "assets/img/sandos4UCards/Blue.png";
import GoldCardImage from "assets/img/sandos4UCards/Gold.png";
import PlatinumCardImage from "assets/img/sandos4UCards/Platinum.png";
import BlackCardImage from "assets/img/sandos4UCards/Black.png";
import CoinsImage from "assets/img/coins.png";
import PropTypes from 'prop-types';
import { getLoy3Profile } from "../../selectors/authentication";

class LoyaltyCard extends React.Component {
  render() {
    const { loy3Profile } = this.props;

    const cardImages = {
      1: BlueCardImage,
      2: GoldCardImage,
      3: PlatinumCardImage,
      4: BlackCardImage,
    };

    const cardImage = loy3Profile ? cardImages[loy3Profile.levelId] : BlueCardImage;

    return (
      <div className="loyalty-card-container">
        {/* Imagen de la tarjeta a la izquierda */}
        <img src={cardImage} alt="Loyalty Card" className="card-image" />

        {/* Contenido a la derecha */}
        <div className="card-content">
          {/* Sección de moneda y coins */}
          <div className="coins-section">
            <img src={CoinsImage} alt="Coins" className="coin-image" />
            <div className="coins-info">
              <span className="coins-amount">{loy3Profile ? loy3Profile.coins : ''}</span>
              <span className="coins-text">Coins</span>
            </div>
          </div>

          {/* Botón "VER MI ACTIVIDAD" */}
          <Link to={'/wallet'}>
            <button className="activity-button">{this.context.t('VIEW MY ACTIVITY')}</button>
          </Link>
        </div>
      </div>
    );
  }
}

LoyaltyCard.propTypes = {
  loy3Profile: PropTypes.object,
};

LoyaltyCard.contextTypes = {
  t: PropTypes.func.isRequired, // para futura internacionalización
};

const mapStateToProps = (state) => ({
  loy3Profile: getLoy3Profile(state),
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyCard);
